export default {
  form: {
    tax_id: {
      label: 'Y-tunnus',
      placeholder: 'Syötä y-tunnus',
    },
    has_vat: {
      label: 'Onko yrityksesi arvonlisäverovelvollinen?',
    },
    vat_id: {
      label: 'ALV',
      placeholder: 'ALV',
      tooltip: 'ALV-numero on yksilöllinen verotunniste, joka tunnistaa yrityksesi',
    },
    tax_percentage: {
      label: 'Verokanta',
      placeholder: 'Verokanta',
    },
    has_dedicated_products_tax: {
      label: 'Verokanta vaihtelee tuotteen mukaan',
    },
  },
  buttons: {
    next: 'Seuraava',
    back: 'Takaisin',
    skip: 'Ohita',
  },
};
